module.exports = __webpack_public_path__ + "media/images/emblems/Chavannes-le-Chene-coat_of_arms-07650c01189342bfc90ec872f0a38fa8.svg";